module.exports = "../static/media/official.024a847f.png";